import { Preset } from "shared-ts/libs/dates/presets"

import { Button } from "../../../../components/base/control/Button"
interface PresetButtonProps {
  preset: Preset
  onSelectPreset: (interval: Preset) => void
  isSelected: boolean
}

export function PresetButton({
  preset,
  onSelectPreset,
  isSelected,
}: PresetButtonProps) {
  return (
    <Button
      onMouseDown={() => onSelectPreset(preset)}
      mode="ghost"
      selected={isSelected}
      size="small"
      tabIndex={-1}
    >
      {preset.displayText}
    </Button>
  )
}
